import React from 'react';
import { Routes, Route,  useLocation } from 'react-router-dom';
import axios from 'axios';        
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home';   
import BusinessTrip from './pages/BusinessTrip';
import VoiceSns from './pages/VoiceSns';
import Raiden from './pages/raiden/raiden';
import Torus from './pages/raiden/torus';
import Ablab from './pages/ablab/Ablab';
import Banner from './pages/banner/Banner';
import ChatBot from './chatbot/components/ChatBot';


function App() { 
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <>
      <Header />
      <Routes>
         {/* トップページ */}
        <Route path="/" element={<Home />} />
         {/* 記事詳細ページ */}
        <Route path="/business_trip" element={<BusinessTrip />} />
        <Route path="/voice_sns" element={<VoiceSns />} />
        <Route path="/raiden" element={<Raiden />} />
        <Route path="/torus" element={<Torus />} />
        <Route path="/banner" element={<Banner />} />
        <Route path="/ablab" element={<Ablab />} />
      </Routes>
      <Footer />
      {isHome && <ChatBot />}
    </>
  );
}

export default App;